//Ao abrir a tela, passar um ?empresa_cnpj=15115563000100 como parametro GET na URL.

//React
import React, { useContext } from "react";

//Material
import {
  Grid,
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@material-ui/core";

import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

//OurComponents
import Chip from "../../../../components/basics/Chip";
import TextFieldErp from "../../../../components/basics/TextFieldErp";
import { HeaderAccordion } from "../styles/Prescricao";
import { PrescricaoContext } from "../contexts/PrescricaoContext";

/* 
  A estilização é feita via Styled Components, uma biblioteca CSS in JS. 
  Com essa lib pode-se criar uma estilização diânimica e hierarquizada.
  É valido dar uma olhada na documentação: https://styled-components.com/;
  Baixar extensão styled components no VsCode.
*/
//Styles

//Controller (functions)
import usePrescricaoController from "../controllers/PrescricaoController";

const AccordionPrescricaoGeral = ({ ...props }) => {
  //Variaveis que serão utilizadas, vindas do 'Controller'
  const {
    expanded,
    precricaoDataValidade,
    setPrecricaoDataValidade,
    receitaTObs,
    setReceitaTObs,
  } = useContext(PrescricaoContext);

  const { handleChangeOpenAcordion } = usePrescricaoController();

  // View
  return (
    <>
      <Grid item xs={12}>
        <Accordion
          expanded={expanded?.geral || false}
          onChange={() => handleChangeOpenAcordion("geral")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <HeaderAccordion>
              <Grid container>
                <Grid item xs={12}>
                  <Chip bgcolor={"default"} label="GERAL" />
                </Grid>
              </Grid>
            </HeaderAccordion>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1}>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <TextFieldErp
                  value={receitaTObs}
                  setValue={setReceitaTObs}
                  label="Observação"
                />
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <TextFieldErp
                  value={precricaoDataValidade}
                  setValue={setPrecricaoDataValidade}
                  label="Validade da receita"
                  type="date"
                />
              </Grid>

              {/* SERÁ ADICIONADO MAIS TARDE
              <Grid item xs={12} style={{ marginTop: 20 }}>
                <Card line="left" lineColor="primary">
                  <HeaderCard>
                    <Grid container>
                      <Chip label="ARQUIVOS DA RECEITA" bgcolor="secondary" />
                    </Grid>
                  </HeaderCard>

                  <Grid item xs={12} style={{ marginTop: 20 }}>
                    <UploadFiles
                      main
                      multiple
                      uploadedFiles={precricaoArquivo}
                      setUploadedFiles={setPrecricaoArquivo}
                    />
                  </Grid>
                </Card>
              </Grid>
              <Grid item xs={12} style={{ marginTop: 20 }}>
                <Card line="left" lineColor="primary">
                  <HeaderCard>
                    <Grid container>
                      <Chip label="FOTOS DO ROSTO" bgcolor="secondary" />
                    </Grid>
                  </HeaderCard>

                  <Grid item xs={12} style={{ marginTop: 20 }}>
                    <UploadFiles
                      main
                      multiple
                      uploadedFiles={facePhotos}
                      setUploadedFiles={setFacePhotos}
                      label="Arraste fotos aqui..."
                    />
                  </Grid>
                </Card>
              </Grid> */}
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </>
  );
};

export { AccordionPrescricaoGeral };
